import moment from 'moment';
import { isMobile } from 'react-device-detect';

import { MobileDiscoveryResponse } from '../models/types/UserDiscoveryResponse.types';
import { Criteria } from '../models/Criteria';
import { StepProps } from '../models/Step';
import { StepType } from '../models/types/step.types';

export enum ActionName {
  Close = 'close',
  Added_Payment = 'addedPayment',
  Added_Group = 'addedGroup',
  Silent_Login = 'silentLogin',
}

export const criteriaMapper = (data: Criteria[]): Criteria[] => {
  return data.map((item) => {
    return {
      id: item.id,
      type: item.type,
      name: item.name,
      label: item.label,
      priority: item.priority,
      description: item.description,
      meta: item.meta,
    };
  });
};

export const getCriteriasUrlByOrigin = (origin: string) => {
  switch (origin) {
    case 'group-discovery-m':
      return 'signup/mobile-discovery';
    default:
      return `criterias/by-origin/${origin}`;
  }
};

export interface FilterCriteriasDataByOriginProps {
  origin: string;
  data: Criteria[] | MobileDiscoveryResponse;
}

export const filterCriteriasDataByOrigin = ({ origin, data }: FilterCriteriasDataByOriginProps): Criteria[] => {
  let res: Criteria[];
  switch (origin) {
    case 'group-discovery-m':
      const mobileDiscoveryResponse = data as MobileDiscoveryResponse;
      res = mobileDiscoveryResponse.criteria;
      break;
    default:
      const criteria = data as Criteria[];
      res = criteria;
      break;
  }
  return criteriaMapper(res);
};

export interface GoToDeepLinkProps {
  mobileLink: string;
  desktopLink: string;
  isAppsflyer: boolean;
}

export const goToDeepLink = ({ mobileLink, desktopLink, isAppsflyer }: GoToDeepLinkProps): void => {
  let url = isMobile ? mobileLink : desktopLink;

  if (isAppsflyer && window.AF_SMART_SCRIPT_RESULT) {
    url = window.AF_SMART_SCRIPT_RESULT.clickURL;
  }

  window.location.href = url;
  return;
};

export const isMobileAppWebView =
  typeof window !== 'undefined' ? window.navigator.userAgent.indexOf('circles-mobile-app') > -1 : false;

export const rearrangeSteps = (steps: StepProps[]) => {
  return steps.map((step) => {
    const {
      metaData,
      id,
      type,
      title,
      description,
      failStepId,
      nextStepId,
      ctaButtonTitle,
      analytics,
      canGoBack,
      canSkip,
      previousStepId,
    } = step;

    let newMetaData = metaData;

    if (type === StepType.Criteria) {
      newMetaData = {
        criteriaType: metaData.criteriaType ?? metaData.type,
        isDiscoveryFinished: metaData.isDiscoveryFinished,
        responseMapping: metaData.responseMapping,
      };
    }
    if (step.type === StepType.PickASegment) {
      newMetaData = {
        failStepId: metaData.failStepId,
        displayPopUp: metaData.displayPopUp,
        criteriaType: metaData.type,
        responseMapping: metaData.responseMapping,
      };
    }

    return {
      stepType: step.stepType ?? type,
      stepName: id,
      title,
      description,
      failStepId,
      nextStepId,
      ctaButtonTitle,
      metaData: newMetaData,
      analytics,
      canGoBack,
      canSkip,
      previousStepId,
    };
  });
};

export const capitalizeFirstLetter = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const getDocumentId = () => {
  const routeId = window.location.pathname.split(`/onboarding/document/`)[1];
  const id = routeId.split('/')[0];
  return id;
};

export const isBetweenNowAnd24HoursFromNow = (stringISO: string) =>
  // subtracting one hour to get live rooms - should be refactored so we will have indication for that from the BE
  moment(stringISO).isBetween(moment().subtract(1, 'hour'), moment().add(24, 'hours'));
